import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PreloaderComponent extends Vue {
    @Prop() public isLoaded!: boolean;
}
